import { Component, inject, Input, OnInit } from '@angular/core'
import Order from '@client/Order'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { Table } from '@ui/Table'
import Payment from '@client/Payment'
import { CdkTableComponent } from '@ui/Components/Table/CdkTable.Component'
import { SystemConfigService } from '@client/Services/SystemConfigService'

@Component({
	selector: 'order-payments',
	templateUrl: './OrderPayments.Component.html',
	imports: [CardComponent, CardContentComponent, CdkTableComponent],
})
export class OrderPaymentsComponent extends Table<Payment> implements OnInit {
	@Input() protected readonly order: Order

	public displayColumns = ['id', 'amount', 'due', 'paid']

	private readonly systemConfigService: SystemConfigService

	constructor() {
		super()
		this.systemConfigService = inject(SystemConfigService)
	}

	public ngOnInit() {
		this.tableEntities = [
			{
				columnDef: 'id',
				header: 'Payment ID',
				accessorKey: 'service_id',
			},
			{
				columnDef: 'amount',
				header: 'Amount',
				accessorKey: 'amount',
				type: 'currency',
				currency: {
					locale: this.systemConfigService.config.locale,
					currency: this.order.currency,
					currencyPrecision: this.order.currency_precision,
				},
			},
			{
				columnDef: 'due',
				header: 'Due Date',
				accessorKey: 'charge_date',
				type: 'date',
			},
			{
				columnDef: 'paid',
				header: 'Paid',
				accessorCallback: (entity: Payment): string =>
					entity.paid ? 'Yes' : 'No',
			},
		]

		this.setTableData(
			this.order.payments.filter((payment: Payment): boolean => payment.paid),
		)
	}
}
